import React from "react";

import { Grid } from "@material-ui/core";
import { RegisterUserSubformProps } from "./RegisterUserSubformProps";
import { UserInfoField } from "common/components";

export const RegisterUserInfoSubform = (props: RegisterUserSubformProps) => (
  <Grid container direction="column" spacing={5}>
    <Grid container item direction="row" spacing={5}>
      <Grid item xs={12} lg={6} md={6} sm={6}>
        <UserInfoField id="firstName" {...props} />
      </Grid>

      <Grid item xs={12} lg={6} md={6} sm={6}>
        <UserInfoField id="lastName" {...props} />
      </Grid>
    </Grid>

    <Grid container item direction="row" spacing={5}>
      <Grid item xs>
        <UserInfoField id="gender" {...props} />
      </Grid>

      <Grid item xs={12} lg={6} md={6} sm={6}>
        <UserInfoField id="cellphone" {...props} />
      </Grid>
    </Grid>

    <Grid item container direction="row" spacing={5}>
      <Grid item lg={6} xs={12} md={6} sm={6}>
        <UserInfoField id="birthDate" {...props} />
      </Grid>

      <Grid item lg={6} md={6} xs={12} sm={6}>
        <UserInfoField id="birthCity" {...props} />
      </Grid>
    </Grid>

    <Grid container item direction="row" alignItems="center" spacing={5}>
      <Grid item lg={6} md={6} xs={12} sm={6}>
        <UserInfoField id="citizenship" className="autocomplete" {...props} />
      </Grid>

      <Grid item xs={12} lg={6} md={6} sm={6}>
        <UserInfoField id="taxNumber" {...props} />
      </Grid>
    </Grid>

    <Grid item xs={12}>
      <UserInfoField id="politicallyExposed" {...props} />
    </Grid>

    <Grid item className="checkbox-center-container" xs={12}>
      <UserInfoField id="notUSTax" {...props} />
    </Grid>
  </Grid>
);
